var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_279_10238)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.29279 6.29259C6.48031 6.10512 6.73462 5.99981 6.99979 5.99981C7.26495 5.99981 7.51926 6.10512 7.70679 6.29259L11.9998 10.5856L16.2928 6.29259C16.385 6.19708 16.4954 6.1209 16.6174 6.06849C16.7394 6.01608 16.8706 5.9885 17.0034 5.98734C17.1362 5.98619 17.2678 6.01149 17.3907 6.06177C17.5136 6.11205 17.6253 6.18631 17.7192 6.2802C17.8131 6.37409 17.8873 6.48574 17.9376 6.60864C17.9879 6.73154 18.0132 6.86321 18.012 6.99599C18.0109 7.12877 17.9833 7.25999 17.9309 7.382C17.8785 7.504 17.8023 7.61435 17.7068 7.70659L12.7068 12.7066C12.5193 12.8941 12.265 12.9994 11.9998 12.9994C11.7346 12.9994 11.4803 12.8941 11.2928 12.7066L6.29279 7.70659C6.10532 7.51906 6 7.26476 6 6.99959C6 6.73443 6.10532 6.48012 6.29279 6.29259ZM6.29279 12.2926C6.48031 12.1051 6.73462 11.9998 6.99979 11.9998C7.26495 11.9998 7.51926 12.1051 7.70679 12.2926L11.9998 16.5856L16.2928 12.2926C16.4814 12.1104 16.734 12.0096 16.9962 12.0119C17.2584 12.0142 17.5092 12.1194 17.6946 12.3048C17.88 12.4902 17.9852 12.741 17.9875 13.0032C17.9897 13.2654 17.8889 13.518 17.7068 13.7066L12.7068 18.7066C12.5193 18.8941 12.265 18.9994 11.9998 18.9994C11.7346 18.9994 11.4803 18.8941 11.2928 18.7066L6.29279 13.7066C6.10532 13.5191 6 13.2648 6 12.9996C6 12.7344 6.10532 12.4801 6.29279 12.2926Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_279_10238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.bcefe7f0552a5f5baa3730fa709ba759.svg";
export { ForwardRef as ReactComponent };